import {
  AI_SPREADSHEET_CELL_KIND,
  type IAiSpreadsheetCellLocation,
} from "./cell";

export const AI_SPREADSHEET_MANUAL_ROW_OUTCOME = {
  placed: "placed",
  needsReview: "needs_review",
} as const;

export type AiSpreadsheetManualRowOutcome =
  (typeof AI_SPREADSHEET_MANUAL_ROW_OUTCOME)[keyof typeof AI_SPREADSHEET_MANUAL_ROW_OUTCOME];

export interface IAiSpreadsheetManualRow {
  id: string;
  sheet_name: string;
  recipient_external_id: string | null;
  cells: Record<string, IManualRowCellInput>;
  anchor: Record<string, unknown>;
  ordinal: number;
  outcome: AiSpreadsheetManualRowOutcome | null;
  added_by?: { id: string; full_name: string | null } | null;
  added_at?: string | null;
  edited_by?: { id: string; full_name: string | null } | null;
  edited_at?: string | null;
  cell?: IAiSpreadsheetCellLocation | null;
}

export interface IManualRowValueCellInput {
  kind?: typeof AI_SPREADSHEET_CELL_KIND.value;
  value: string | number | boolean | null;
  value_type?: string | null;
}

export interface IManualRowFormulaCellInput {
  kind: typeof AI_SPREADSHEET_CELL_KIND.formula;
  raw_input: string;
  value_type?: string | null;
}

export type IManualRowCellInput =
  | IManualRowValueCellInput
  | IManualRowFormulaCellInput;

export interface IManualRowInput {
  cells: Record<string, IManualRowCellInput>;
  anchor?: { after_row?: number };
}

export interface IManualRowsResponse {
  manual_rows: IAiSpreadsheetManualRow[];
}
